import type { Infer } from 'superstruct';
import {
	array,
	assign,
	object,
	omit,
	optional,
	partial,
	string,
} from 'superstruct';

import {
	FacebookBehavior,
	FacebookInterest,
	ViewFacebookAdSetTemplateDto,
} from '@adflow/shared/data-facebook-ads';

import { historyArrayItem } from '../history-array-item';
import { IdMapStruct } from '../id-map';

import { HistoryFacebookAdTemplateDto } from './history-facebook-ad.dto';
import { HistoryFacebookAdSetBudgetTemplateDto } from './history-facebook-adset-budget.dto';
import { HistoryFacebookAdSetLocationTemplateDto } from './history-facebook-adset-location.dto';

export const HistoryFacebookAdSetTemplateDto = assign(
	partial(omit(ViewFacebookAdSetTemplateDto, ['updatedAt'])),
	partial(
		object({
			interests: array(historyArrayItem(FacebookInterest)),
			behaviors: array(historyArrayItem(FacebookBehavior)),
			platforms: array(historyArrayItem(string())),
			platformPositions: array(historyArrayItem(string())),
			placementSoftOptOut: optional(array(historyArrayItem(string()))),
			adSetBudgetTemplates: IdMapStruct(HistoryFacebookAdSetBudgetTemplateDto),
			adSetLocationTemplates: IdMapStruct(
				HistoryFacebookAdSetLocationTemplateDto
			),
			adTemplates: array(historyArrayItem(HistoryFacebookAdTemplateDto)),
			// Only used to distinguish ad sets on UI
			adSetName: optional(string()),
		})
	)
);

export type HistoryFacebookAdSetTemplateDto = Infer<
	typeof HistoryFacebookAdSetTemplateDto
>;
